export default {"src":"/_next/static/media/organization-details.28badc93.svg","height":270,"width":395,"blurWidth":0,"blurHeight":0};